import React from 'react';
import { MainLogo } from '../MainLogo';

export default function SidebarHeader() {
    return (
        <div className="sidebar__header">
            <a href="/dashboard">
                <MainLogo width={128} height={26} />
            </a>
        </div>
    );
}
